// extracted by mini-css-extract-plugin
export default {"container":"NotFoundPage_container__uO++y","inner":"NotFoundPage_inner__2bvsj"};